import { useTranslation } from 'react-i18next';
import { SvgRecording } from '../../../../icons';
import { localizedRelativeTime } from '../../../../utils/ats-details-utils';
import { RecordButton } from '../../details-button/record-button';
import { appendSequenceNumbers } from '../../utils';
import { CallToAction } from '../call-to-action-button';
import { ProgramCallToActionProps } from './program-call-to-action';

export function RecordCallToAction({ focusedAsset, source }: ProgramCallToActionProps) {
  const { t } = useTranslation();

  return (
    <RecordButton asset={focusedAsset} source={source}>
      {({ hasRecording, open }) => (
        <CallToAction
          text={{
            primary: appendSequenceNumbers(
              hasRecording ? t('details:manage-recording') : t('details:record'),
              focusedAsset,
            ),
            secondary: localizedRelativeTime(source.startTime, 'airtime'),
          }}
          image={{
            src: source.image,
            alt: source.name,
          }}
          icon={<SvgRecording />}
          onClick={open}
        />
      )}
    </RecordButton>
  );
}
